import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/close_ic.svg';
import _imports_1 from '@/assets/icon/icon_unchecked.png';
import _imports_2 from '@/assets/icon/icon_checked.png';
const _withScopeId = n => (_pushScopeId("data-v-e5b26de2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "quanWrapper" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "font-w500 font-36" }, "优惠券", -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "p-lr32 p-t20" };
const _hoisted_8 = { class: "list" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "roundBox" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "round1 ig-border-2 border-box" }),
    /*#__PURE__*/ _createElementVNode("div", { class: "round2 ig-border-2 border-box" })
], -1));
const _hoisted_11 = { class: "couponInfo flex-align-center border-box" };
const _hoisted_12 = { class: "name text-overflow flex-1 font-w500 font-32" };
const _hoisted_13 = { class: "flex-align-center" };
const _hoisted_14 = { class: "msg themeColor" };
const _hoisted_15 = { class: "num font-w500" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "font-36" }, "¥", -1));
const _hoisted_17 = { class: "men font-24" };
const _hoisted_18 = { class: "radio" };
const _hoisted_19 = {
    class: "icon-check",
    src: _imports_1,
    alt: ""
};
const _hoisted_20 = {
    class: "icon-check",
    src: _imports_2,
    alt: ""
};
const _hoisted_21 = { class: "desc p-lr32 flex-between gray-9 font-24 p-tb16" };
const _hoisted_22 = { class: "left" };
const _hoisted_23 = { class: "time" };
import { ref, watch } from 'vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            type: Array,
            default: () => []
        },
        status: {
            type: String,
            default: 'hide' // hide 隐藏 up 上升 down 下降
        },
        couponId: {
            type: Number,
            default: 0
        }
    },
    emits: ['closeTip'],
    setup(__props, { emit: emits }) {
        const props = __props;
        watch(() => props.couponId, () => {
            counponId.value = props.couponId;
        });
        const counponId = ref(0);
        // 关闭弹框
        const closeTip = () => {
            emits('closeTip');
        };
        const selectCoupon = item => {
            counponId.value = item.id;
            emits('closeTip', item.id);
        };
        // const showList = ref([] as Array<number>)
        // const showDesc = (id: number) => {
        //   let ind = showList.value.indexOf(id)
        //   if (ind > -1) {
        //     showList.value.splice(ind, 1)
        //   } else {
        //     showList.value.push(id)
        //   }
        // }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("dl", {
                    class: _normalizeClass(["listBox white-bg", {
                            linearUp: __props.status == 'up',
                            hideDown: __props.status == 'down'
                        }])
                }, [
                    _createElementVNode("dt", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("div", {
                            class: "closeIcon",
                            onClick: _withModifiers(closeTip, ["stop"])
                        }, _hoisted_6, 8, _hoisted_4)
                    ]),
                    _createElementVNode("dd", _hoisted_7, [
                        _createVNode(BetterScroll, {
                            options: {
                                scrollY: true,
                                scrollX: false,
                                click: true,
                                mouseWheel: true,
                                scrollbar: {
                                    fade: false,
                                    interactive: true
                                }
                            },
                            loaded: __props.status == 'up',
                            domStyle: {
                                position: 'relative',
                                height: 'calc(100vh - 3.1rem)',
                                width: '6.86rem'
                            }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ul", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "ig-border-2",
                                            key: item.id,
                                            onClick: _withModifiers(($event) => (selectCoupon(item)), ["stop"])
                                        }, [
                                            _hoisted_10,
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, _toDisplayString(item.sourceId), 1),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _hoisted_16,
                                                            _createElementVNode("span", null, _toDisplayString(item.price), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.useLimit ? '满' + item.useLimit + '可用' : '无门槛'), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                                                            [_vShow,
                                                                (item.id != counponId.value && counponId.value) ||
                                                                    (!item.selectOption && !counponId.value)
                                                            ]
                                                        ]),
                                                        _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                                                            [_vShow,
                                                                item.id == counponId.value ||
                                                                    (item.selectOption && !counponId.value)
                                                            ]
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, " 有效期：" + _toDisplayString(item.createdAt + ' 至 ' + item.expireAt), 1)
                                                ])
                                            ])
                                        ], 8, _hoisted_9));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 8, ["loaded", "domStyle"])
                    ])
                ], 2)
            ], 512)), [
                [_vShow, __props.status != 'hide']
            ]);
        };
    }
});
